import { render, staticRenderFns } from "./service-money.vue?vue&type=template&id=385d2105&"
import script from "./service-money.vue?vue&type=script&lang=js&"
export * from "./service-money.vue?vue&type=script&lang=js&"
import style0 from "./service-money.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports